import ReservationCertificate from './ReservationCertificate';
export default ReservationCertificate;
